import { render } from "./GeneratorBasicInfo.vue?vue&type=template&id=190dee21&scoped=true"
import script from "./GeneratorBasicInfo.vue?vue&type=script&lang=js"
export * from "./GeneratorBasicInfo.vue?vue&type=script&lang=js"

import "./GeneratorBasicInfo.vue?vue&type=style&index=0&id=190dee21&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-190dee21"]])

export default __exports__